import { isDefined } from '#misc/is-defined.guard';

/**
 * Checks if the current environment is a browser.
 * This is determined by the presence of `window`, `navigator`, and `document` objects.
 *
 * @returns {boolean} True if in a browser environment, otherwise false.
 */
export const isBrowser = isDefined(window) && isDefined(navigator) && isDefined(document);
